/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, nthChildIterator, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT PREVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
	preview: {
		// see reporthelpers for how these animatins tie together
		'& .previewhead': {
			opacity: '0',
        	animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.15s',
			display: 'flex',
			flexDirection: 'column',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
            marginBottom: pxToEm(10),
			'& .daterange, .datalastupdated': {
				marginBottom: pxToEm(5)
			}
		},
		'& .tablewrapper': {
			opacity: '0',
			animationName: 'fadeIn',
	        animationDuration: '.2s',
	        animationFillMode: 'forwards',
	        animationDelay: '.4s',
	        '& .tableview': {
	        	position: 'relative',
	        	zIndex: '2',
				'& tr': {
					opacity: '0',
					animationName: 'fadeInUp',
			        animationDuration: '.2s',
			        animationFillMode: 'forwards'
				},
				'& thead': {
					'& tr': {
						extend: nthChildIterator(2, .4, .03)
					}
				},
				'& tbody': {
					'& tr': {
						extend: nthChildIterator(100, .5, .03)
					}
				}
			},
			'& .name-tablemessage': {
				opacity: '0',
	        	animationName: 'fadeInDown',
	            animationDuration: '.2s',
	            animationFillMode: 'forwards',
	            animationDelay: '1s',
	            position: 'relative',
	            zIndex: '1',
			}
		},
		// **** DISABLE IF PROCESSING ***** //
		'&.processing-true': {
			'& .button:not(.processing-true)': { extend: disable }
		}
	}
});
